import React, {
    useState,
    ChangeEvent,
} from 'react';
import {
    useHistory,
    useParams,
} from 'react-router-dom';
import {History} from 'history';
import {curry} from 'ramda';

import useQuery from '@pluto/query-hook';
import {formQuery} from '@pluto/rest';
import {UseParamsId} from '@pluto/@types';
import User from './User';
import {
    UserTabs,
    HandleChange,
    SetCurrentTab,
} from './UserTypes';

export interface HandleChangeParams {
    setCurrentTab: SetCurrentTab;
    history: History;
    id?: string;
}

export default function UserContainer() {
    const {id}: UseParamsId = useParams();
    const history = useHistory();
    const query = useQuery();
    const tabValue = query.get('tab') as UserTabs;
    const initialTabValue = getInitialTabValue(tabValue);
    
    const [currentTab, setCurrentTab] = useState<UserTabs>(initialTabValue);
    
    const onHandleChange: HandleChange = handleChange({
        setCurrentTab,
        history,
        id,
    });
    
    return (
        <User
            currentTab={currentTab}
            onHandleChange={onHandleChange}
        />
    );
}

export const getInitialTabValue = (tabValue: UserTabs | undefined): UserTabs => tabValue || UserTabs.UserDetails;

export const handleChange = curry((params: HandleChangeParams, event: ChangeEvent<{}>, newValue: UserTabs) => {
    const {
        setCurrentTab,
        history,
        id,
    } = params;
    const queryParams = {
        tab: newValue,
    };
    const search = formQuery('', queryParams);
    
    setCurrentTab(newValue);
    history.push({
        pathname: `/users/${id}`,
        search,
    });
});
